import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";
import Alert from "react-s-alert";

import { hashFromObj } from "../lib/utils/hash";

import { normalize, Schema, arrayOf } from "normalizr";

const user = new Schema("users", { idAttribute: "uid" });

const State = Record(
  {
    map: Map(),
    results: Map(),
    meta: new (Record(
      {
        currentPage: 1,
        limit: 15,
        offset: 0,
        sortDir: "desc",
        sortField: "createdAt"
      },
      "meta"
    ))(),
    deleteStatus: 0,
    form: new (Record(
      {
        loading: false,
        error: null
      },
      "form"
    ))()
  },
  "user"
);

const usersReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.GET_USERS_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, { users: arrayOf(user) });
      return state
        .update("map", map => map.merge(nrs.entities.users))
        .update("results", rs => rs.set(hashFromObj(data), nrs.result));
    }

    case actions.GET_USER_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, user);
      return state.update("map", map => map.merge(nrs.entities.users));
    }

    case actions.DELETE_USER: {
      return state.setIn(["deleteStatus"], 1);
    }

    case actions.DELETE_USER_SUCCESS: {
      return state.setIn(["deleteStatus"], 2);
    }

    case actions.DELETE_USER_ERROR: {
      return state.setIn(["deleteStatus"], 3);
    }

    case actions.SET_DELETE_STATUS: {
      const { status } = action.payload;
      return state.setIn(["deleteStatus"], status);
    }

    case actions.SET_USER_PAGE: {
      const { page } = action.payload;
      const limit = state.getIn(["meta", "limit"]);
      return state
        .setIn(["meta", "currentPage"], page)
        .setIn(["meta", "offset"], (page - 1) * limit);
    }

    case actions.SET_USER_SORT: {
      const { field, dir } = action.payload;
      return state
        .setIn(["meta", "sortDir"], dir)
        .setIn(["meta", "sortField"], field);
    }

    case actions.USER_CLEAR_ERROR: {
      const { field } = action.payload;

      let errors =
        state.form.error && state.form.error && state.form.error.errors;
      if (errors && errors[field]) {
        errors[field] = undefined;
      }

      return state.setIn(["form", "error"], new ValidationError(errors));
    }

    case actions.USER_CLEAR_FORM: {
      return state.setIn(["form", "error"], null);
    }

    default:
      return state;
  }
};

export default usersReducer;



// WEBPACK FOOTER //
// ./src/common/user/reducer.js